import { SHARED_ENV } from './environment.shared';

export const environment = {
  ...SHARED_ENV,
  production: true,
  firebase: {
    apiKey: 'AIzaSyCdjjkea9L5E1s2DTw3-KGPsIRWloyKvwY',
    authDomain: 'staging-6a224.firebaseapp.com',
    projectId: 'staging-6a224',
    storageBucket: 'staging-6a224.firebasestorage.app',
    messagingSenderId: '1098191325844',
    appId: '1:1098191325844:web:c973960df32cccbc2e4281'
  },
  mainSystemUrl: 'https://sunip-staging.legalsight.com',
  forecasterUrl: 'https://chiefip-staging.legalsight.com',
  subscribeKey: 'sub-c-edc0a898-c7d6-11e8-9ca5-92bdce849b25',
  local: false,
  raygunKey: '8eS6ffrx62kQYwborG0SKQ==',
  msClarityProjectId: 'rjggcz2xz9',
  msClarityEnabled: true,
};
